import { render, staticRenderFns } from "./AddCreditComponent.vue?vue&type=template&id=b58514c4&"
import script from "./AddCreditComponent.vue?vue&type=script&lang=js&"
export * from "./AddCreditComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports